import React, { useContext } from 'react';
import classnames from 'classnames';
import { PapiDaBrowseFaceted } from '@wix/da-types-papi';
import { BiLoggerContextProvider } from '@wix/da-shared-react/pkg/biLogger';
import { MobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';
import { useFlag } from '@wix/da-shared-react/pkg/redux/flags/hooks';
import { FilterOption } from '../../../types/api';
import Strips from '../Strips';
import ContentTypeFilterDropdown from '../ContentTypeFilterDropdown';
import MobileOrderDropdown from './_partials/MobileOrderDropdown';
import NavigationBar from './_partials/NavigationBar';

import s from './FacetPage.scss';

export interface Props {
  initialOffset?: number;
  orderOptions?: PapiDaBrowseFaceted['orderOptions'];
  filterOptions?: FilterOption[];
  order?: string;
  withMargin?: boolean;
  children?: React.ReactNode;
}

const FacetPage: React.FC<Props> = ({
  initialOffset = 0,
  orderOptions = [],
  filterOptions = [],
  order,
  withMargin = true,
  children,
}) => {
  const isMobile = useContext(MobileContext);
  const top_strips_on_browse = useFlag('top_strips_on_browse');
  const hasFilterBar = orderOptions.length + filterOptions.length > 0;

  return (
    <div
      className={classnames(
        s['root'],
        withMargin && s['with-margin'],
        !hasFilterBar && s['no-filter-bar']
      )}
    >
      <BiLoggerContextProvider
        value={{
          sectionname: 'general',
          _rankOffset: initialOffset,
        }}
      >
        {top_strips_on_browse && <Strips areTopStrips />}
        {hasFilterBar &&
          (isMobile ? (
            <div className={s['mobile-dropdowns']}>
              <ContentTypeFilterDropdown />
              <MobileOrderDropdown order={order} orderOptions={orderOptions} />
            </div>
          ) : (
            <NavigationBar order={order} orderOptions={orderOptions} />
          ))}
        {children}
      </BiLoggerContextProvider>
    </div>
  );
};
FacetPage.displayName = 'FacetPage';

export default FacetPage;
